export const entities = [
    {
        name: 'CompanyStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'prospect', name: 'Prospect' },
            { id: 'client', name: 'Client' },
            { id: 'abandoned', name: 'Abandonné' },
            { id: 'target', name: 'Cible' }
        ]
    },
    {
        name: 'ContactStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'prospect', name: 'À confirmer' },
            { id: 'confirmed', name: 'Confirmé' },
            { id: 'inTouch', name: 'En contact' }
        ]
    },

    {
        name: 'Civility',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'M', name: 'Monsieur' },
            { id: 'Mme', name: 'Madame' }
        ]
    },
    {
        name: 'ActionStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'todo', name: 'À faire' },
            { id: 'ongoing', name: 'En cours' },
            { id: 'blocked', name: 'Bloqué' },
            { id: 'done', name: 'Terminé' },
            { id: 'skipped', name: 'Sans objet' },
            { id: 'abandoned', name: 'Abandonné' }
        ]
    },
    {
        name: 'WorkItemStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'todo', name: 'À faire' },
            { id: 'ongoing', name: 'En cours' },
            { id: 'blocked', name: 'Bloqué' },
            { id: 'done', name: 'Terminé' },
            { id: 'onHold', name: 'En pause' },
            { id: 'abandoned', name: 'Abandonné' }
        ]
    },
    {
        name: 'WorkItemOverride',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'onHold', name: 'En pause' },
            { id: 'abandoned', name: 'Abandonné' }
        ]
    },
    {
        name: 'ProductKind',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'platform', name: 'Plateforme' },
            { id: 'solution', name: 'Solution' },
            { id: 'custom', name: 'Sur mesure' }
        ]
    },
    {
        name: 'DeploymentStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'setup', name: 'En mise en place' },
            { id: 'live', name: 'En production' },
            { id: 'suspended', name: 'Suspendu' },
            { id: 'ended', name: 'Terminé' }
        ]
    },
    {
        name: 'OpportunityTarget',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'solution', name: 'Solution' },
            { id: 'custom', name: 'Sur mesure' }
        ]
    },
    {
        name: 'OpportunityStage',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'target', name: 'Cible' },
            { id: 'contacted', name: 'Contacté' },
            { id: 'meeting', name: 'Rendez-vous' },
            { id: 'proposal', name: 'Proposition' },
            { id: 'negotiation', name: 'Négociation' },
            { id: 'won', name: 'Gagné' },
            { id: 'lost', name: 'Perdu' },
            { id: 'abandoned', name: 'Abandonné' }
        ]
    },
    {
        name: 'Status',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'actif', name: 'Actif' },
            { id: 'inactif', name: 'Inactif' }
        ]
    },
    {
        name: 'Scope',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'regional', name: 'Régionale' },
            { id: 'national', name: 'Nationale' },
            { id: 'european', name: 'Européenne' },
            { id: 'international', name: 'Internationale' }
        ]
    },
    {
        name: 'Influence',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'low', name: 'Faible' },
            { id: 'medium', name: 'Moyen' },
            { id: 'high', name: 'Élevé' }
        ]
    },
]
